import { bannerRecipeDispatchers } from 'src/components/bannerRecipe/dispatchers';

import { sendOldmaAnalyticsEvent } from "src/services/telemetry/providers/OldmaAnalytics";

function onRecipeDeliveryConfirmationViewedEvent() {
    sendOldmaAnalyticsEvent({
        id: 'd-v1-e129',
        name: 'Recipe Delivery Confirmation Viewed'
    });
}

function onRecipeDeliveryConfirmationClickedEvent() {
    sendOldmaAnalyticsEvent({
        id: 'd-v1-e130',
        name: 'Recipe Delivery Confirmation Clicked'
    });
}

function onRecipeOnboardingClickedEvent() {
    sendOldmaAnalyticsEvent({
        id: 'd-v1-e131',
        name: 'Recipe Onboarding Clicked'
    });
}

function onRecipeAgreementClickedEvent() {
    sendOldmaAnalyticsEvent({
        id: 'd-v1-e132',
        name: 'Recipe Agreement Clicked'
    });
}

bannerRecipeDispatchers.onRecipeDeliveryConfirmationViewed.subscribe(onRecipeDeliveryConfirmationViewedEvent);
bannerRecipeDispatchers.onRecipeDeliveryConfirmationClicked.subscribe(onRecipeDeliveryConfirmationClickedEvent);
bannerRecipeDispatchers.onRecipeOnboardingClicked.subscribe(onRecipeOnboardingClickedEvent);
bannerRecipeDispatchers.onRecipeAgreementClicked.subscribe(onRecipeAgreementClickedEvent);
